import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

export interface DonutChartSegment {
	dashArray: string[]; // Defines the area that is filled by the slice
	dashOffset: string; // Defines the offset of the slice in regards to the the north-zero-point
	dashColor: string; // Defines the color of the slice
	circleClass?: object | string; // Class for the circle
}

export interface DonutChartLogo {
	logoSrc: string;
	logoWidth: number;
	logoDefault: string;
	logoAlt: string;
}

@Component({
	selector: "bp-donut-chart",
	templateUrl: "./bp-donut-chart.component.html",
	styleUrls: ["./bp-donut-chart.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpDonutChartComponent {
	@Input()
	public customClasses: object | string = {};

	@Input()
	public labelCustomClasses: object | string = {};

	@Input()
	public donutChartSegments: DonutChartSegment[] = [];

	@Input()
	public viewBox: string = "0 0 45 45";

	@Input()
	public strokeWidth: string = "4";

	@Input()
	public strokeLinecap: "butt" | "round" | "square" = "butt";

	@Input()
	public centerMainText: string = "";

	@Input()
	public centerSecondaryText: string = "";

	@Input()
	public dropShadow: boolean = false;

	@Input()
	public logo: DonutChartLogo = null;

	@Input()
	public donutRadius: number = 15.91549430918954;
}
